export default "__VITE_ASSET__06946bb0__"